import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../webcommon/common/checkbox/Checkbox';

import styles from './checkboxCell.module.scss';

const CheckboxCell = props => (
    <div className={ styles.checkboxWrapper }>
        <Checkbox
            checked={ props.checked }
            onChange={ props.onChange }
        />
    </div>
);

CheckboxCell.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

export default CheckboxCell;
